export { GroupInfoTelegramComponent } from './group-info-telegram.component';
export { GroupInfoTelegramModule } from './group-info-telegram.module';
